import { FunctionComponent } from 'react'

import styled, { css, useTheme } from 'styled-components'

import SvgIcon from '@components/SvgIcon'

export interface PlayIconProps {
  isVisible: boolean
}

const IconWrapper = styled.div<PlayIconProps>`
  ${({
    isVisible,
    theme: {
      colors: { staticBlack },
      utils: { opacity },
    },
  }) => css`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    width: 80px;
    height: 80px;

    display: flex;
    justify-content: center;
    align-items: center;

    border-radius: 50%;
    background: ${opacity(staticBlack, '80')};

    ${isVisible
      ? css`
          transition: all 100ms ease-in-out;
          visibility: visible;
        `
      : css`
          opacity: 0;
          visibility: hidden;
          transition: all 200ms ease-in-out;
        `}
  `}
`

const PlayIcon: FunctionComponent<PlayIconProps> = ({ isVisible }) => {
  const theme = useTheme()

  return (
    <IconWrapper isVisible={isVisible}>
      <SvgIcon
        iconName="play-solid"
        size={40}
        color={theme.colors.staticWhite}
      />
    </IconWrapper>
  )
}

export default PlayIcon
